// extracted by mini-css-extract-plugin
export var borderRadius = "_f6-4";
export var large = "_f6-3";
export var logoContainer = "_f6-0";
export var nameLogo = "_f6-2";
export var small = "_f6-1";